export default (options) => {
  const primaryColor = '#0052c7'
  return {
    '&': { height: options.height + 'px', width: '100%', background: options.bgColor, borderRadius: '4px' },
    '&.cm-editor.cm-focused': { outline: 'none' },
    '.ͼb': { userSelect: 'none' },
    '.ͼg': { color: primaryColor },
    '.cm-custom-function-name': { color: primaryColor },
    ' .cm-cursor': { borderLeftColor: primaryColor },
    '.cm-activeLine': { backgroundColor: options.lineActiveColor },
    '.cm-gutters': { display: 'none' },
    '.cm-scroller': { overflow: 'auto' },
    '.cm-line': { padding: `2px ${options.padding}px` },
    '.cm-content': { padding: `${options.padding}px 0` },
    '.cm-tooltip.cm-tooltip-autocomplete': {
      'background': '#fff',
      'borderRadius': '4px',
      'border': '0px',
      'overflow': 'hidden',
      'boxShadow': '1px 10px 10px #ccc',
      '& > ul': {
        'fontFamily': 'monospace',
        'whiteSpace': 'nowrap',
        'overflow': 'hidden auto',
        'maxWidth_fallback': '700px',
        'maxWidth': 'min(700px, 95vw)',
        'minWidth': '250px',
        'maxHeight': '10em',
        'height': '100%',
        'listStyle': 'none',
        'margin': 0,
        'padding': 0,
        '& > li': {
          overflowX: 'hidden',
          textOverflow: 'ellipsis',
          cursor: 'pointer',
          padding: '1px 3px',
          lineHeight: 1.5
        }
      }
    },
    '.cm-tooltip-autocomplete ul li[aria-selected]': {
      background: primaryColor,
      color: 'white'
    },
    '.cm-tooltip-autocomplete-disabled ul li[aria-selected]': {
      background: '#777'
    },
    '.cm-field-name': {
      height: '24px',
      lineHeight: '22px',
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '14px',
      fontSize: '13px',
      // margin: '0 2.5px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
      // fontVariantLigatures: 'contextual',
      padding: '0 10px',
      background: '#f9f0ff',
      border: '1px solid #d3adf7',
      color: '#722ed1',
      ...(options.fieldNameStyles || {})
    }
  }
}
